import { render } from "./AppointmentQuery.vue?vue&type=template&id=638e6c5c&scoped=true"
import script from "./AppointmentQuery.vue?vue&type=script&lang=js"
export * from "./AppointmentQuery.vue?vue&type=script&lang=js"

import "./AppointmentQuery.vue?vue&type=style&index=0&id=638e6c5c&scoped=true&lang=css"

import exportComponent from "/Volumes/Transcend INNCOM/INNCOM Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638e6c5c"]])

export default __exports__